import _ from 'lodash';

// ---------------------------------------------------------------------------

const FLEX_VALUE_TO_CSS = {
  flexStart: 'flex-start',
  flexEnd: 'flex-end',
  spaceBetween: 'space-between',
  spaceAround: 'space-around',
  spaceEvenly: 'space-evenly',
  rowReverse: 'row-reverse',
  columnReverse: 'column-reverse',
  wrapReverse: 'wrap-reverse',
};

export function flexValueToCss(value) {
  return _.get(FLEX_VALUE_TO_CSS, value, value);
}

export function pxToNumber(value) {
  if (_.isNumber(value)) return value;
  return parseInt(value, 10) || 0;
}

export function numberToPx(value) {
  return `${pxToNumber(value)}px`;
}

export function resolvePadding(padding) {
  if (_.isNumber(padding) || _.isString(padding)) {
    const v = pxToNumber(padding);
    return { topLeft: v, topRight: v, bottomRight: v, bottomLeft: v, lock: true };
  }
  return {
    topLeft: pxToNumber(_.get(padding, 'topLeft', 0)),
    topRight: pxToNumber(_.get(padding, 'topRight', 0)),
    bottomRight: pxToNumber(_.get(padding, 'bottomRight', 0)),
    bottomLeft: pxToNumber(_.get(padding, 'bottomLeft', 0)),
    lock: _.get(padding, 'lock', false),
  };
}

export function paddingToStored(sidePadding) {
  return {
    topLeft: numberToPx(sidePadding.topLeft),
    topRight: numberToPx(sidePadding.topRight),
    bottomRight: numberToPx(sidePadding.bottomRight),
    bottomLeft: numberToPx(sidePadding.bottomLeft),
    lock: sidePadding.lock,
  };
}

export function paddingToCss(padding) {
  const p = resolvePadding(padding);
  return `${p.topLeft}px ${p.topRight}px ${p.bottomRight}px ${p.bottomLeft}px`;
}

export const MOBILE_MAX_PADDING = 20;

export function capPaddingSides(padding, max = MOBILE_MAX_PADDING) {
  const p = resolvePadding(padding);
  return {
    topLeft: Math.min(p.topLeft, max),
    topRight: Math.min(p.topRight, max),
    bottomRight: Math.min(p.bottomRight, max),
    bottomLeft: Math.min(p.bottomLeft, max),
    lock: p.lock,
  };
}
